import React from 'react';
import s from './Customer.scss';
import get from 'lodash.get';
import { Text } from '@wix/design-system';
import { addressFormatter } from '@wix/crm-financial-formatters';
import { withTranslation } from '@wix/fe-essentials/i18n';
import { WithCustomerLoader, } from '../../loaders/loaders-builder';
const Customer = withTranslation()(({ t, customer }) => {
    const email = get(customer, 'email.address');
    const companyName = get(customer, 'company.name');
    const name = get(customer, 'name');
    const phoneNumber = get(customer, 'phone.number');
    const street = get(customer, 'address.street');
    const city = get(customer, 'address.city');
    const state = get(customer, 'address.state');
    const zip = get(customer, 'address.zip');
    const country = get(customer, 'address.country');
    const localizedLocation = addressFormatter({
        t,
        street,
        // @ts-expect-error
        city,
        // @ts-expect-error
        state,
        // @ts-expect-error
        zip,
        // @ts-expect-error
        country,
    });
    return (React.createElement("div", { className: s.customer },
        React.createElement(Text, { className: s.customerName, size: "tiny", weight: "bold", dataHook: "customer-name" }, `${companyName
            ? t('invoice-view:price-quote.view.to-customer', { name })
            : name}`),
        !!companyName && (React.createElement(Text, { size: "tiny", weight: "bold", dataHook: "company-name" }, companyName)),
        !!email && (React.createElement(Text, { size: "tiny", weight: "thin", dataHook: "customer-email" }, email)),
        !!localizedLocation && (React.createElement(Text, { size: "tiny", weight: "thin", dataHook: "customer-address-location" }, localizedLocation)),
        !!phoneNumber && (React.createElement(Text, { size: "tiny", weight: "thin", dataHook: "customer-phone-number" }, phoneNumber))));
});
export default WithCustomerLoader(withTranslation(['invoice-view', 'locale-data'])(Customer));
//# sourceMappingURL=Customer.js.map